import { createAction, props } from '@ngrx/store';
import { ICorrelationParams } from '@nx-ng/types';
import { Action } from '@ngrx/store';
import { ApiError, GetFareResponse, TicketProduct } from '../../client/src';

export const LOAD_FLEXI_FARES_TYPE = '[Fares/Ticket Selectors] Load FlexiFares';
export const loadFlexiFares = createAction(LOAD_FLEXI_FARES_TYPE);

export const loadFlexiFaresSuccess = createAction(
  `${LOAD_FLEXI_FARES_TYPE} Success`,
  props<{ fareResponse: GetFareResponse }>()
);

export const loadFlexiFaresFailure = createAction(
  `${LOAD_FLEXI_FARES_TYPE} Failure`,
  props<{ error?: string | ApiError; retryAction?: Action }>()
);

export const LOAD_PAYG_FARES_TYPE = '[Fares/Ticket Selectors] Load Payg Fares';
export const loadPaygFares = createAction(LOAD_PAYG_FARES_TYPE);

export const loadPaygFaresSuccess = createAction(
  `${LOAD_PAYG_FARES_TYPE} Success`,
  props<{ fareResponse: GetFareResponse }>()
);

export const loadPaygFaresFailure = createAction(
  `${LOAD_PAYG_FARES_TYPE} Failure`,
  props<{ error?: string | ApiError; retryAction?: Action }>()
);

export const LOAD_FARE_BY_ID_TYPE = '[Fares/Ticket Selectors] Load Fare By Id';
export const loadFareById = createAction(
  LOAD_FARE_BY_ID_TYPE,
  props<{
    ticketID: string;
    correlationParams?: ICorrelationParams;
    quantity?: number;
  }>()
);

export const loadFareByIdSuccess = createAction(
  `${LOAD_FARE_BY_ID_TYPE} Success`,
  props<{
    fareResponse: TicketProduct;
    correlationParams?: ICorrelationParams;
  }>()
);

export const loadFareByIdFailure = createAction(
  `${LOAD_FARE_BY_ID_TYPE} Failure`,
  props<{
    error?: string | ApiError;
    correlationParams?: ICorrelationParams;
    retryAction?: Action;
  }>()
);

export const LOAD_FARE_BY_ALIAS_TYPE =
  '[Fares/Ticket Selectors] Load Fare By Alias';
export const loadFareByAlias = createAction(
  LOAD_FARE_BY_ALIAS_TYPE,
  props<{
    ticketAlias: string;
    quantity?: number;
    basketId?: string;
  }>()
);

export const loadFareByAliasSuccess = createAction(
  `${LOAD_FARE_BY_ALIAS_TYPE} Success`,
  props<{
    fareResponse: TicketProduct;
    basketId?: string;
  }>()
);

export const loadFareByALiasFailure = createAction(
  `${LOAD_FARE_BY_ALIAS_TYPE} Failure`,
  props<{ error?: string | ApiError; retryAction?: Action }>()
);

export const SEARCH_FARES_TYPE = '[Fares/Ticket Selectors] Search Fares';
export const searchFares = createAction(SEARCH_FARES_TYPE);

export const searchFaresSuccess = createAction(
  `${SEARCH_FARES_TYPE} Success`,
  props<{ fareResponse: GetFareResponse }>()
);

export const searchFaresFailure = createAction(
  `${SEARCH_FARES_TYPE} Failure`,
  props<{ error?: string | ApiError; retryAction?: Action }>()
);
